import Vue from 'vue'
import store from './store'
import router from './router'
import i18n from './plugins/i18n'
import App from './components/App'

import './helpers'
import './plugins'
import './components'
import './filters'

Vue.config.productionTip = false

new Vue({
    i18n,
    store,
    router,
    ...App
})


// WEBPACK FOOTER //
// ./resources/assets/js/app.js